import { ca } from '@cian/analytics';

export function trackNavigateToBClientPromo() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click',
    label: 'bclient_promo',
  });
}
